import { NgModule, APP_INITIALIZER } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { AuthInterceptorProvider } from './auth.interceptor';

export function authInitializerFactory(auth: AuthService, router: Router) {
  return () => auth.validateWithExternalLogin().then((ok) => {
    if (ok) {
      // If user landed on auth-required during bootstrap, send them to home
      const current = router.url;
      if (current === '/auth-required' || current === '/' || current === '') {
        router.navigateByUrl('/home');
      }
    }
  });
}

@NgModule({
  providers: [
    AuthInterceptorProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: authInitializerFactory,
      deps: [AuthService, Router],
      multi: true
    }
  ]
})
export class AuthModule {}


